import { createI18n } from 'vue-i18n'

import { en } from '@/translations/en'
import { pl } from '@/translations/pl'

const i18n = createI18n({
  locale: 'pl',
  messages: {
    en,
    pl,
  },
})

export { i18n }
